interface Props {
  title: string
  className?: string
  style?: object
}

const Badge = ({ title, className, style }: Props) => {
  const styles = {
    ...{ boxShadow: '0px 1px 1px rgba(0, 0, 0, 0.3)' },
    ...style,
  }

  return (
    <span style={styles} className={`${className} rounded-sm text-base px-2`}>
      {title}
    </span>
  )
}

export default Badge
